//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {computed, defineComponent, useRoute, ref, nextTick} from '@nuxtjs/composition-api';
import { useUiState, useUiHelpers } from '~/composables';
import { getCMSLabels, showingOfProductsTitle } from '~/helpers/globalLabels';
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
import SfSelect from "~/themes/fiskarsMoominDefault/components/components/molecules/SfSelect/SfSelect.vue";
import MoominDropdown from "~/themes/fiskarsMoominDefault/components/components/molecules/MoominDropdown/MoominDropdown.vue";
import {useVSFContext} from "@vue-storefront/core";
import LazyHydrate from 'vue-lazy-hydration';
export default defineComponent({
  name: 'CategoryHeader',
  components: {
    SfButton,
    SfIcon,
    SfSelect,
    LazyHydrate,
    MoominDropdown
  },
  props: {
    sortingOptions: {
      type: Array
    },
    selectedOption: {
      type: String,
      default: ''
    },
    selectedFilters: {
      type: [Array, Object],
      default: () => []
    },
    filters: {
      type: Object,
      default: () => []
    },
    totalCountFilteredProducts: {
      type: Number,
      default: 0
    },
    resultsShowing: {
      type: Number,
      default: 0
    },
  },
  setup(props, { emit }) {
    const { changeSorting } = useUiHelpers();
    const { toggleFilterSidebar } = useUiState();
    const { i18n } = useVSFContext();
    const route = useRoute();
    const routeQuery = computed(() => route.value.query);

    //Filter title from the CMS
    const filtersTitle = getCMSLabels('filters');

    const getChosenValue = (optionChosen) => {
      let result = optionChosen;

      if(typeof result === 'string') {
        result = JSON.parse(result);
      }

      emit('processSorting', result);

    }

    const clearAllLabel = getCMSLabels('clear-all');

    const _categoryHeader = computed(() => {
      return showingOfProductsTitle(props.resultsShowing, props.totalCountFilteredProducts)
    });

    const clearFilterAriaLabel = (filter) => {
      return i18n.t("buttons.filters.clear-filter").replace('{0}', filter.label);
    }

    const filterAnnouncement = ref('');

    const handleRemoveFilter = (filter) => {
      emit("onRemoveFilter", filter);

      filterAnnouncement.value = "";
      nextTick(() => {
        filterAnnouncement.value = i18n.t('buttons.filters.removed-filter').replace('{0}', filter.label);
      });
    };

    const handleRemoveAllFilters = () => {
      emit('onClearAllFilters');

      filterAnnouncement.value = "";
      nextTick(() => {
        filterAnnouncement.value = i18n.t('buttons.filters.removed-all-filters');
      });
    };

    return {
      _categoryHeader,
      clearAllLabel,
      filterAnnouncement,
      handleRemoveFilter,
      handleRemoveAllFilters,
      changeSorting,
      getChosenValue,
      toggleFilterSidebar,
      route,
      routeQuery,
      showingOfProductsTitle,
      filtersTitle,
      clearFilterAriaLabel,
    };
  }
});
